import React from "react";
import PropTypes from "prop-types";
import ProgressBar from "react-bootstrap/ProgressBar";

const UploadBar = function ({ percentCompleted }) {
  return <ProgressBar animated now={percentCompleted} label={`${percentCompleted}%`} />;
};

UploadBar.propTypes = {
  percentCompleted: PropTypes.number,
};

UploadBar.defaultProps = {
  percentCompleted: 0,
};

export default UploadBar;
